import React, { useEffect, useRef } from 'react';
import * as PANOLENS from 'panolens';
import myImage from "../assets/images/360_image/Commercial/360_1.jpg";
import { useLocation } from 'react-router';
// import { useParams } from 'react-router';

const Panolens360Viewer = () => {
  // const index = useParams("id")
  const location = useLocation();
  
  const viewerRef = useRef(null); // Reference for the container div
  const panolensViewerRef = useRef(null); // Reference for Panolens Viewer instance
  const panoramaRef = useRef(null); // Reference for Panorama instance
  const wakeLockRef = useRef(null);
  
    useEffect(() => {
    const requestWakeLock = async () => {
      try {
        if ('wakeLock' in navigator) {
          wakeLockRef.current = await navigator.wakeLock.request('screen');

          // Reacquire lock when visibility changes (like when user switches tabs)
          document.addEventListener('visibilitychange', async () => {
            if (wakeLockRef.current !== null && document.visibilityState === 'visible') {
              wakeLockRef.current = await navigator.wakeLock.request('screen');
            }
          });
        } else {
          console.warn('Wake Lock API not supported on this browser.');
        }
      } catch (err) {
        console.error(`${err.name}, ${err.message}`);
      }
    };

    requestWakeLock();

    return () => {
      if (wakeLockRef.current) {
        wakeLockRef.current.release();
        wakeLockRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const viewer = new PANOLENS.Viewer({
      container: viewerRef.current,
      autoRotate: false, // Disable auto-rotation
      controlBar: true,  // Show control bar
      deviceOrientation: true,
      viewIndicator: false,
      enableReticle :false
      // enableReticle: false
    });

    const panoramaSrc = location?.state?.image || location?.state?.img || myImage;
    const panorama = new PANOLENS.ImagePanorama(panoramaSrc);
    viewer.add(panorama);
    viewer.reticle.hide()
    // if (viewer.reticle) {
    //   viewer?.reticle?.ring?.material?.color?.set('red'); // Change to red
    //   viewer.reticle?.dot?.material?.color?.set('red'); // Change dot to green
    // }
    // viewer.disableReticleControl();
    // viewer.enableReticleControl(false);
    viewer.enableControl(PANOLENS.CONTROLS.DEVICEORIENTATION);

    // Simulate enabling Cardboard mode after rendering
    setTimeout(() => {
      viewer.enableEffect(PANOLENS.MODES.CARDBOARD);
    }, 1000); // Delay to ensure everything is rendered
    // Store instances in refs
    panolensViewerRef.current = viewer;
    panoramaRef.current = panorama;

    return () => {
      // Properly dispose of Panorama and Viewer on unmount
      if (panoramaRef.current) {
        panoramaRef.current.dispose();
        panoramaRef.current = null;
      }
      if (panolensViewerRef.current) {
        panolensViewerRef.current.dispose();
        panolensViewerRef.current = null;
      }
    };
  }, []);

  return <div ref={viewerRef} style={{ width: '100%',height:"70vh" }} />;
};

export default Panolens360Viewer;
